import {
  UPDATE_SHOW_COUNTER_LIST_MODE,
  UPDATE_SHOW_COUNTER_TYPE_LIST_MODE,
  UPDATE_SHOW_PROJECTS_LIST_MODE,
  UPDATE_SHOW_USERS_LIST_MODE,
  UPDATE_SHOW_PROJECT_WATER_COUNTERS_LIST_MODE,
  UPDATE_SHOW_PROJECT_POWER_COUNTERS_LIST_MODE,
  UPDATE_SHOW_PROJECT_GAS_COUNTERS_LIST_MODE,
} from "../actions/Types";

const initialState = {
  showUsersTableMode: true,
  showProjectsTableMode: false,
  showCounterTypeTableMode: true,
  showCounterTableMode: true,
  showProjectWaterCountersTableMode: true,
  showProjectPowerCountersTableMode: true,
  showProjectGasCountersTableMode: true,
};

const ComponentStatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SHOW_USERS_LIST_MODE:
      return {
        ...state,
        showUsersTableMode: action.payload.showUsersTableMode,
      };
    case UPDATE_SHOW_PROJECTS_LIST_MODE:
      return {
        ...state,
        showProjectsTableMode: action.payload.showProjectsTableMode,
      };
    case UPDATE_SHOW_COUNTER_TYPE_LIST_MODE:
      return {
        ...state,
        showCounterTypeTableMode: action.payload.showCounterTypeTableMode,
      };
    case UPDATE_SHOW_COUNTER_LIST_MODE:
      return {
        ...state,
        showCounterTableMode: action.payload.showCounterTableMode,
      };
    case UPDATE_SHOW_PROJECT_WATER_COUNTERS_LIST_MODE:
      return {
        ...state,
        showProjectWaterCountersTableMode:
          action.payload.showProjectWaterCountersTableMode,
      };
    case UPDATE_SHOW_PROJECT_POWER_COUNTERS_LIST_MODE:
      return {
        ...state,
        showProjectPowerCountersTableMode:
          action.payload.showProjectPowerCountersTableMode,
      };
    case UPDATE_SHOW_PROJECT_GAS_COUNTERS_LIST_MODE:
      return {
        ...state,
        showProjectGasCountersTableMode:
          action.payload.showProjectGasCountersTableMode,
      };
    default:
      return state;
  }
};

export default ComponentStatesReducer;
